export default __webpack_public_path__ + "static/media/heroempresas.8243d7f7.jpg";